import { Trans } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import useUrlBuilder from '/business/shared/hooks/useUrlBuilder';
import { userPermissions } from '/business/shared/util/Statics';

import Button from '/shared/components/widgets/button/Button';
import LinkButton from '/shared/components/widgets/button/LinkButton';

import getApplicationAuthRuleSelector from '/business/shared/state/selectors/auth/getApplicationAuthRuleSelector';

import StyledHeaderApplicationSubNavMenu from '/business/shared/components/widgets/header/__styled__/StyledHeaderApplicationSubNavMenu';
import StyledHeaderSubNavActions from '/business/shared/components/widgets/header/__styled__/StyledHeaderSubNavActions';

import LogoutIcon from '/shared/images/icons/bp-logout-white.svg';
import PersonIcon from '/shared/images/icons/bp-people-one-white.svg';
import ChevronLeftIcon from '/shared/images/icons/icon-chevron-left-neon-green.svg';
import CogIcon from '/shared/images/icons/icon-settings-cog.svg';
import type { RootState } from '/business/shared/state/store';

function HeaderApplicationSubNavMenu() {
  const hasApplicationSettingsAuth = useSelector((state: RootState) =>
    getApplicationAuthRuleSelector(state, userPermissions.VIEW_APPLICATION_SETTINGS),
  );

  const navigate = useNavigate();
  const { getApplicationSettingsUrl } = useUrlBuilder();
  return (
    <StyledHeaderApplicationSubNavMenu>
      <StyledHeaderSubNavActions>
        <div>
          <LinkButton
            $secondary
            $small
            $icon={ChevronLeftIcon}
            onClick={() => {
              navigate('/');
            }}
          >
            {/* @i18n: Back to dashboard */}
            <Trans i18nKey="business:Buttons.linkDashboardBack" />
          </LinkButton>
        </div>
      </StyledHeaderSubNavActions>
      <StyledHeaderSubNavActions $isAlignedRight>
        {hasApplicationSettingsAuth && (
          <div>
            <LinkButton
              $secondary
              $small
              $icon={CogIcon}
              onClick={() => {
                navigate(getApplicationSettingsUrl('/business-details'));
              }}
            >
              {/* @i18n: Settings */}
              <Trans i18nKey="business:ApplicationSettings.title" />
            </LinkButton>
          </div>
        )}
        <div>
          <LinkButton
            $secondary
            $small
            $icon={PersonIcon}
            onClick={() => {
              navigate('/my-profile');
            }}
          >
            {/* @i18n: My profile */}
            <Trans i18nKey="business:Buttons.linkProfile" />
          </LinkButton>
        </div>
        <div>
          <Button
            $secondary
            $small
            $icon={LogoutIcon}
            onClick={() => {
              navigate('/sso/logout');
            }}
          >
            {/* @i18n: Log out */}
            <Trans i18nKey="business:Buttons.linkLogout" />
          </Button>
        </div>
      </StyledHeaderSubNavActions>
    </StyledHeaderApplicationSubNavMenu>
  );
}

export default HeaderApplicationSubNavMenu;
